import SeoHead from "@/components/public/SeoHead";
import Breadcrumb from "@/components/public/Breadcrumb";

export default function PolitiqueConfidentialitePage() {
  return (
    <div data-testid="politique-confidentialite-page">
      <SeoHead title="Politique de confidentialité" description="Politique de confidentialité de Nettoyage Expert. Traitement des données personnelles conformément à la LPD suisse." path="/politique-de-confidentialite" noindex={true} />
      <Breadcrumb items={[{ name: "Accueil", url: "/" }, { name: "Politique de confidentialité" }]} />
      <section className="py-16 sm:py-24 bg-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 prose prose-slate max-w-none">
          <h1 className="text-3xl sm:text-4xl font-semibold text-[#062133] tracking-tight mb-8" data-testid="privacy-h1">Politique de confidentialité</h1>

          <h2 className="text-xl font-semibold text-[#062133] mt-10 mb-4">Responsable du traitement</h2>
          <div className="bg-[#F4F6F8] rounded-lg p-6 my-4 text-sm text-[#062133]/80 leading-relaxed space-y-1">
            <p><strong>HOMELY SOLUTIONS Sàrl</strong></p>
            <p>Rue Jean-André-Venel 4, 1400 Yverdon-les-Bains, Suisse</p>
            <p>IDE : CHE-418.697.448 — N° TVA : CHE-418.697.448 TVA</p>
            <p>Email : <a href="mailto:info@nettoyage-expert.ch" className="text-[#336DBF]">info@nettoyage-expert.ch</a></p>
            <p>Téléphone : <a href="tel:+41245391033" className="text-[#336DBF]">+41 24 539 10 33</a></p>
          </div>

          <h2 className="text-xl font-semibold text-[#062133] mt-10 mb-4">Base légale</h2>
          <p className="text-[#062133]/70 leading-relaxed">
            Le traitement des données personnelles est régi par la Loi fédérale sur la protection des données (LPD, RS 235.1) et son ordonnance (OPDo). Le Règlement général sur la protection des données de l'UE (RGPD) s'applique dans la mesure où nous traitons des données de personnes situées dans l'UE/EEE.
          </p>

          <h2 className="text-xl font-semibold text-[#062133] mt-10 mb-4">Données collectées</h2>
          <p className="text-[#062133]/70 leading-relaxed">Nous collectons les données suivantes :</p>
          <ul className="text-[#062133]/70 space-y-2 mt-3">
            <li><strong>Données de contact</strong> : nom, prénom, adresse email, numéro de téléphone, adresse postale — lors d'une demande de devis ou de contact.</li>
            <li><strong>Données de prestation</strong> : type de service demandé, surface, lieu d'intervention — pour l'établissement du devis et la réalisation de la prestation.</li>
            <li><strong>Données de navigation</strong> : adresse IP, type de navigateur, pages visitées — collectées automatiquement par les journaux du serveur.</li>
          </ul>

          <h2 className="text-xl font-semibold text-[#062133] mt-10 mb-4">Finalités du traitement</h2>
          <ul className="text-[#062133]/70 space-y-2 mt-3">
            <li>Répondre aux demandes de devis et de contact</li>
            <li>Fournir et améliorer nos prestations de nettoyage</li>
            <li>Gérer la relation commerciale (facturation, suivi)</li>
            <li>Améliorer le site web et l'expérience utilisateur</li>
            <li>Respecter nos obligations légales et réglementaires</li>
          </ul>

          <h2 className="text-xl font-semibold text-[#062133] mt-10 mb-4">Durée de conservation</h2>
          <p className="text-[#062133]/70 leading-relaxed">
            Les données de contact et de prestation sont conservées pendant la durée de la relation commerciale, puis pendant 10 ans conformément aux obligations légales suisses en matière de comptabilité (Code des obligations, art. 958f). Les données de navigation sont conservées pendant 12 mois maximum.
          </p>

          <h2 className="text-xl font-semibold text-[#062133] mt-10 mb-4">Destinataires des données</h2>
          <p className="text-[#062133]/70 leading-relaxed">
            Vos données personnelles ne sont jamais vendues à des tiers. Elles peuvent être partagées avec :
          </p>
          <ul className="text-[#062133]/70 space-y-2 mt-3">
            <li><strong>Notre hébergeur</strong> : Infomaniak Network SA (Genève, Suisse) — hébergement du site web et des emails</li>
            <li><strong>Nos prestataires techniques</strong> : uniquement dans la mesure nécessaire à la fourniture de nos services</li>
            <li><strong>Les autorités compétentes</strong> : en cas d'obligation légale</li>
          </ul>
          <p className="text-[#062133]/70 leading-relaxed mt-3">
            Toutes les données sont hébergées en Suisse. Aucun transfert de données vers un pays tiers n'est effectué.
          </p>

          <h2 className="text-xl font-semibold text-[#062133] mt-10 mb-4">Vos droits</h2>
          <p className="text-[#062133]/70 leading-relaxed">
            Conformément à la LPD, vous disposez des droits suivants :
          </p>
          <ul className="text-[#062133]/70 space-y-2 mt-3">
            <li><strong>Droit d'accès</strong> : obtenir la confirmation du traitement de vos données et en recevoir une copie</li>
            <li><strong>Droit de rectification</strong> : demander la correction de données inexactes</li>
            <li><strong>Droit à l'effacement</strong> : demander la suppression de vos données (dans les limites légales)</li>
            <li><strong>Droit d'opposition</strong> : vous opposer au traitement de vos données à des fins de marketing</li>
            <li><strong>Droit à la portabilité</strong> : recevoir vos données dans un format structuré et lisible</li>
          </ul>
          <p className="text-[#062133]/70 leading-relaxed mt-3">
            Pour exercer ces droits, contactez-nous à <a href="mailto:info@nettoyage-expert.ch" className="text-[#336DBF]">info@nettoyage-expert.ch</a>. Nous répondons dans un délai de 30 jours.
          </p>

          <h2 className="text-xl font-semibold text-[#062133] mt-10 mb-4">Sécurité des données</h2>
          <p className="text-[#062133]/70 leading-relaxed">
            Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour protéger vos données contre tout accès non autorisé, perte, destruction ou altération. La transmission des données entre votre navigateur et notre serveur est chiffrée via le protocole HTTPS/TLS.
          </p>

          <h2 className="text-xl font-semibold text-[#062133] mt-10 mb-4">Autorité de surveillance</h2>
          <p className="text-[#062133]/70 leading-relaxed">
            Si vous estimez que le traitement de vos données viole la LPD, vous pouvez adresser une réclamation au Préposé fédéral à la protection des données et à la transparence (PFPDT) : <a href="https://www.edoeb.admin.ch" target="_blank" rel="noopener noreferrer" className="text-[#336DBF]">www.edoeb.admin.ch</a>.
          </p>

          <p className="text-[#062133]/40 text-xs mt-12">Dernière mise à jour : septembre 2026</p>
        </div>
      </section>
    </div>
  );
}
